const DEFAULT_API_URL = 'http://localhost:8080';
const DEFAULT_API_FALLBACK_URL = 'https://us-central1-flowium-423301.cloudfunctions.net/virtual_file_system_api';

const normalizeApiUrl = (url?: string): string | undefined => {
    const trimmed = url?.trim();
    if (!trimmed) return undefined;
    return trimmed.replace(/\/$/, '');
};

const shouldPreferFallback = (primary: string, fallback?: string): boolean => {
    if (!fallback) return false;

    const hostname = (() => {
        try {
            return new URL(primary).hostname;
        } catch {
            return '';
        }
    })();

    return /(^|\.)api\.flowium\.io$/.test(hostname);
};

const PRIMARY_API_URL = normalizeApiUrl(import.meta.env.REACT_APP_API_URL) || DEFAULT_API_URL;
const FALLBACK_API_URL = normalizeApiUrl(import.meta.env.REACT_APP_API_FALLBACK_URL) || DEFAULT_API_FALLBACK_URL;
const FALLBACK_FOR_CLIENT = shouldPreferFallback(PRIMARY_API_URL, FALLBACK_API_URL)
    ? FALLBACK_API_URL
    : undefined;

export const API_URL_PRIMARY = PRIMARY_API_URL;
export const API_URL_FALLBACK = FALLBACK_API_URL;

export const API_URL_CLIENT = FALLBACK_FOR_CLIENT || PRIMARY_API_URL;

export const API_URL_CLIENT_FALLBACK = FALLBACK_FOR_CLIENT ? PRIMARY_API_URL : FALLBACK_API_URL;

export const API_URL_SNIPPETS = API_URL_CLIENT;
